import { delay, filter, map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { selectIsTraderEventRunning } from "../../../selectors/selectTraderEventInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionEventInfo } from "../../info/event/actionEventInfo";
import { actionTraderEventReceived, TypeActionTraderEventInfo } from "../actionTraderEventInfo";
export var epicTraderEventInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionEventInfo.Received ||
            action.type === TypeActionEventInfo.StartEvent ||
            action.type === TypeActionTraderEventInfo.Request;
    }), delay(100), filter(function () {
        return selectIsTraderEventRunning(state$.value);
    }), switchMap(function () {
        var playerId = selectOwnPlayerId(state$.value);
        return deps
            .netSend({
            id: CommandCode.TraderInfo,
            props: {
                playerId: playerId,
            },
        })
            .pipe(map(actionTraderEventReceived), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/epics/epicTraderEventInfo.ts
// module id = 2457
// module chunks = 3